export default __webpack_public_path__ + "static/media/Snd_CX.7cccd7d4.mp3";